var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSemiCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 628.08 420.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fcd2c9;}.cls-3{fill:#8facda;}.cls-4{fill:#f89b6c;}.cls-5{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,257.57C0,115.32,140.6,0,314,0s314,115.32,314,257.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 254.5,
    width: 628.08,
    height: 165.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.02 205.62 169.22 215.79 175.6 207.59 173.19 217.7 182.49 213.09 175.93 221.15 186.31 221.04 176.91 225.46 186.31 229.87 175.93 229.76 182.49 237.82 173.19 233.21 175.6 243.32 169.22 235.12 167.02 245.29 164.82 235.12 158.44 243.32 160.85 233.21 151.55 237.82 158.11 229.76 147.73 229.87 157.13 225.46 147.73 221.04 158.11 221.15 151.55 213.09 160.85 217.7 158.44 207.59 164.82 215.79 167.02 205.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M464.41,169.7a18.28,18.28,0,0,1-10.71-13.28A18.24,18.24,0,0,1,443,169.7c-1.08.47-3.76,1.19-3.76,1.19s2.68.72,3.76,1.19a18.23,18.23,0,0,1,10.7,13.27,18.26,18.26,0,0,1,10.71-13.27c1.08-.47,3.76-1.19,3.76-1.19s-2.68-.72-3.76-1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461.29,148.84a1.52,1.52,0,1,1-1.51-1.51,1.52,1.52,0,0,1,1.51,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.37,198.15a1.52,1.52,0,1,1-1.52-1.52,1.52,1.52,0,0,1,1.52,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197,235.69a1.52,1.52,0,1,1-1.51-1.51,1.52,1.52,0,0,1,1.51,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.16,135.75c-3.21-.13-6.47-.13-6.5-.13h-4.17l1.19-1.19s1.49-1.5,2.89-3c2.91-3.15,2.66-3.4,2.53-3.54s-.39-.38-3.55,2.52c-1.52,1.4-3,2.88-3,2.9l-1.19,1.19v-4.17s0-3.29-.14-6.5c-.27-6.62-.79-6.62-1-6.62s-.78,0-1.05,6.62c-.13,3.21-.14,6.47-.14,6.5v4.17l-1.19-1.19s-1.49-1.5-3-2.9c-3.16-2.91-3.41-2.65-3.55-2.52s-.38.39,2.53,3.54c1.4,1.52,2.88,3,2.89,3l1.19,1.19h-4.17s-3.28,0-6.5.13c-6.62.27-6.62.8-6.62,1.06s0,.78,6.62,1.05c3.22.13,6.47.13,6.5.13h4.17l-1.19,1.2s-1.49,1.49-2.89,3c-2.91,3.16-2.66,3.41-2.53,3.54s.39.39,3.55-2.52c1.52-1.4,3-2.88,3-2.89l1.19-1.2v4.17s0,3.29.14,6.51c.27,6.61.8,6.61,1.05,6.61s.78,0,1-6.61c.14-3.22.14-6.47.14-6.51v-4.17l1.19,1.2s1.49,1.49,3,2.89c3.16,2.91,3.41,2.66,3.55,2.52s.38-.38-2.53-3.54c-1.4-1.52-2.87-3-2.89-3l-1.19-1.2h4.17s3.29,0,6.5-.13c6.62-.27,6.62-.8,6.62-1.05s0-.79-6.62-1.06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Type"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.59,100.52l-4.71,3.4-.9-1.25,11.74-8.48.9,1.25-4.71,3.4L130,110.08l-2.32,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.25,88.45a7.92,7.92,0,1,1-2.41,10.89A7.76,7.76,0,0,1,134.25,88.45Zm7.69,12.19c2.53-1.6,2.62-4.54.46-8s-4.86-4.62-7.39-3-2.63,4.54-.46,8S139.39,102.24,141.94,100.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.36,89.68l-2-1.42a5.51,5.51,0,0,1-3,4.37,7.39,7.39,0,0,1-10.49-3.12,7.93,7.93,0,0,1,3.32-11,6.73,6.73,0,0,1,7.09,0l-.45,1.7a5.05,5.05,0,0,0-5.59-.38c-2.69,1.46-3.54,4.5-1.63,8s4.8,4.57,7.35,3.18a3.25,3.25,0,0,0,1.6-4.37l-1.33-2.44,2.55-1.39,3.48,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.77,73.24l9.91-4.71.67,1.41L165,73.43l2.2,4.61,5.38-2.56.67,1.41-5.39,2.56,2.4,5,7.65-3.63.68,1.43-10.23,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.18,66.12l-5.37,2.22-.59-1.42,13.38-5.53.59,1.42L183.82,65l5.3,12.81-2.65,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.89,59.78l2.7-1,2.21,6.31,7.7-2.69-2.21-6.31,2.7-1,5.08,14.54-2.69.94L206,63.9l-7.71,2.7,2.37,6.77-2.7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.53,53.45l10.54-3.09.44,1.5-7.79,2.29,1.44,4.9,5.72-1.68.44,1.5-5.72,1.68,1.57,5.36,8.13-2.39.45,1.52-10.88,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.41,63.34l-2.77.67-3.62-15,6.34-1.54c3.08-.74,5.91-.27,6.63,2.68.63,2.61-1.38,4.22-3.59,4.8v.07a3.63,3.63,0,0,1,4.07,1.84l1.28,1.93a8.14,8.14,0,0,0,1.87,2l-3.12.75A10.69,10.69,0,0,1,239,59.77l-1.45-2.19c-.87-1.35-1.6-1.74-3.33-1.32l-2.4.58Zm-1.92-8,2.74-.66c2.07-.51,3.32-1.62,2.82-3.69-.45-1.87-2-2.4-4.17-1.87l-2.73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.64,47.63l-1.91,10.28-1.15.18L250.3,43.72l2.92-.46,5.85,10.5,1.43-8.23-1.72-3.15,2.84-.45L267,52.28l2.15-11.55,1.78-.28-3.13,16.18-1.15.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.78,55.07l-2.84.32-1.71-15.31,2.84-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.34,40.36l-5.79.43-.12-1.54,14.44-1,.11,1.53-5.79.43,1,13.82-2.85.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301.46,38l2.86-.05.12,6.69,8.16-.14-.12-6.69,2.86,0,.27,15.4-2.86.05L312.63,46l-8.17.14.13,7.17-2.86,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333,39.84l-5.81-.32.09-1.54,14.46.8-.09,1.53L335.8,40,335,53.84l-2.85-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M346.21,39.15l2.84.3-.7,6.65,8.11.86.71-6.65,2.84.3-1.62,15.32-2.84-.3.75-7.14-8.12-.86-.75,7.14-2.85-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.75,41.4l10.85,1.69-.24,1.55-8-1.25-.79,5,5.9.92-.24,1.54-5.9-.91-.86,5.52,8.37,1.3-.24,1.57-11.2-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381.4,59.69l-2.81-.54L381.48,44l2.81.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.18,61.29l-2.79-.64,3.45-15,6.37,1.47c3.09.71,5.41,2.39,4.73,5.35-.6,2.62-3.12,3.16-5.36,2.7l0,.06a3.64,3.64,0,0,1,2.82,3.47l.28,2.3a8,8,0,0,0,.77,2.66l-3.13-.72a10.19,10.19,0,0,1-.5-2.33l-.33-2.6a2.54,2.54,0,0,0-2.39-2.67l-2.4-.56Zm1.83-8,2.75.63c2.08.47,3.69,0,4.17-2.05.43-1.86-.7-3-2.89-3.53l-2.74-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414.29,51.77l10.2,3.1L424,56.36l-7.47-2.27L415,59.17l5.7,1.73-.46,1.51-5.7-1.73-2,6.65-2.74-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M431.66,69.11,425.81,67l-3.15,3.44-1.7-.61,11.53-12.34,1.12.39,1.24,16.87-2.84-1Zm-4.79-3.21,4.68,1.66-.47-6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M456,66.87l3.14,1.34-6,14.17-2.59-1.1,5-11.75-9.88,9.74-.91-.38.2-13.86-5,11.75-1.7-.73,6-14.17,3.4,1.45-.17,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M460.14,85.84l-2.57-1.24,6.71-13.87L466.85,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M472,74.5l2.53,1.35L468,88l6.87,3.67-.74,1.39-9.4-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M480.06,96.62l-2.46-1.45,7.81-13.28,2.46,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M492.81,86.31l9.2,6-.85,1.31-6.8-4.42-2.78,4.28,5,3.25L495.73,98l-5-3.25-3,4.69,7.1,4.61-.87,1.33-9.5-6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M505.25,105.78l-1.36-1.71c-1.66-2.12-2.25-3.92-.82-5.85,1.56-2.13,4.57-2.24,7.19-.31a6.51,6.51,0,0,1,2.94,5.61l-1.68.32a5.14,5.14,0,0,0-2.18-4.72c-1.4-1-2.87-1.08-3.7.06s-.44,2,.74,3.44l1.36,1.75c1.64,2,2.26,3.95.84,5.88-1.8,2.45-5,2.39-7.7.43a7.22,7.22,0,0,1-3.21-6.44l1.67-.19a6,6,0,0,0,2.5,5.34c1.5,1.1,3.14,1.33,4.12,0C506.81,108.24,506.35,107.19,505.25,105.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.49,130.84c12.55,0,20.07,2.78,20.07,11.5,0,6.17-4.88,12.11-16.77,13.46l-.07.15c10,.61,15.11,4.14,15.11,10.38,0,13.54-13.91,17.15-27.07,17.15H181.61l.38-1.43h4l8.27-49.78h-4.51l.23-1.43Zm-10.76,51.21h1.58c7,0,12.26-6.32,12.26-15.87,0-6.54-2.33-9.32-8-9.32H204Zm4.59-26.62h.23c6.16,0,11.5-3.84,11.5-14.74,0-5.49-2.48-8.42-7.44-8.42H208Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.72,155.43c0,7.37-8.05,9.55-15,10.53a46.15,46.15,0,0,1-5.87.37c-1.05,10.61,1.05,15.19,6.32,15.19,3.68,0,7.74-2.63,10.37-10.83l1.51.46c-2.78,9.24-8.27,13.08-17.3,13.08-9.55,0-15.19-5.11-15.19-14,0-15.41,9.33-23.31,22.64-23.31C263.65,146.93,267.72,149.86,267.72,155.43Zm-13.24-7.07c-4.06,0-6.39,7.44-7.52,16.54,5.11-.22,9.78-2.7,9.78-12C256.74,150.16,256.28,148.36,254.48,148.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.68,177.69c-3.46,4.89-6,6.54-11,6.54-6.91,0-10.37-3-10.37-9.47,0-2.79.3-5.19,2.48-16l6-30.31h-5.34l.23-1.35H294l-8.72,46.77a34.06,34.06,0,0,0-.83,5.19c0,1.35.45,2.11,1.88,2.11,1.2,0,2.86-1,5.19-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.3,177.69c-3.46,4.89-6,6.54-11,6.54-6.92,0-10.38-3-10.38-9.47,0-2.79.3-5.19,2.48-16l6-30.31h-5.33l.22-1.35h19.25l-8.72,46.77A34.06,34.06,0,0,0,311,179c0,1.35.45,2.11,1.88,2.11,1.2,0,2.86-1,5.19-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366.38,177.84c-2.71,4.43-5.94,6.39-10.08,6.39-7.44,0-10.22-3.76-9-9.85l-.38-.08c-2,5.87-5.86,9.93-12.4,9.93-8.73,0-12.11-5-12.11-13.08,0-13.84,6.31-24.22,18.5-24.22,5.56,0,7.29,2.11,8.42,5l1.05-4c3.61.07,10.83,0,13.76-.6-1.88,9.25-3.83,18-5.49,28.87a21.21,21.21,0,0,0-.3,2.71c0,2,.91,2.41,2,2.41s2.78-.75,5-4.14Zm-20.61-5.12a59.94,59.94,0,0,0,2.64-17.52c0-4.51-2.11-6.24-4.21-6.24-2.26,0-3.84,2.11-5.34,7.37a82,82,0,0,0-3,19.48c0,2.55.3,5.49,3.23,5.49C341.41,181.3,344,178.67,345.77,172.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.85,183.22c-.62,9.92-5.89,19.29-22,19.29-11.78,0-18.73-4.22-18.73-12.09,0-7.57,7.88-11.66,17.8-12.47v-.25c-7.63-.24-13-3.28-13-8.55,0-7.69,7.87-11.41,18.72-11.41,6.08,0,12.71,1.74,12.71,8.37,0,5-3.22,6.63-6,6.63-5.33,0-5.4-5.27-4-7.5h3.29c2.1-4.21,0-6.26-3.48-6.26-3.72,0-7.81,2.67-7.81,10.79,0,2.48.44,6,1.68,7.62a10.88,10.88,0,0,1,4.09-1.17c1,0,2.29.37,2.29,1.86s-1.3,2-2.6,2a8.16,8.16,0,0,1-4.16-1.67c-3,2.54-5.08,5.39-5.08,11.78,0,4.9,2.23,9.67,9.55,9.67,9.05,0,14.69-8,15-16.43l-8.49,1.06c-1.8.24-2,.86-2.36,2.79l-.93-.07c.25-8.43,2.17-12,6-12.71,2.35-.37,12.15-1.55,14.75-2.11,1.12-.24,1.68-.74,1.93-2.79l1,.07c.31,6.26-1.12,11.9-5.46,12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.69,215l-2.18-14.81h-4.59l.22-1.43H261l-.22,1.43h-4.29L263,240.46l16.32-40.23h-5.26l.22-1.43H285.9l-.31,1.43h-4l-20.53,51.21H250.93l-5.57-32.79-14.51,32.79h-9.63l-8-51.21H209l.15-1.43h21.73l-.15,1.43h-3.61l6.7,39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M303,245.57c-2.71,4.22-5.49,6.62-11.05,6.62-5.72,0-9.63-2.4-9.63-8.72a50.65,50.65,0,0,1,1-7.3L287.18,217h-5.95l.23-1.36h19.93c-3,14.59-4.29,21.14-5.27,26.4a40.39,40.39,0,0,0-.75,5.26c0,1.36.75,1.81,1.58,1.81,1.35,0,2.93-1.35,5-4.36Zm-16-41c0-5.11,4.52-8.12,9.78-8.12,4.29,0,6.92,1.95,6.92,5.71,0,5.12-4.59,8-9.7,8C288.53,210.23,287,207.15,287,204.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.14,245.65c-3.46,4.89-6,6.54-11,6.54-6.92,0-10.38-3-10.38-9.47,0-2.79.3-5.19,2.48-16l6-30.31h-5.34l.22-1.35h19.26l-8.73,46.77a35.36,35.36,0,0,0-.83,5.19c0,1.36.46,2.11,1.89,2.11,1.2,0,2.85-1,5.18-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.76,245.65c-3.46,4.89-6,6.54-11,6.54-6.92,0-10.38-3-10.38-9.47,0-2.79.3-5.19,2.48-16l6-30.31h-5.34l.23-1.35H357l-8.73,46.77a35.15,35.15,0,0,0-.82,5.19c0,1.36.45,2.11,1.88,2.11,1.2,0,2.85-1,5.19-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.89,223.39c0,7.37-8.05,9.55-15,10.53a46.15,46.15,0,0,1-5.87.37c-1.05,10.61,1,15.19,6.32,15.19,3.68,0,7.74-2.63,10.37-10.82l1.51.45c-2.78,9.25-8.27,13.08-17.3,13.08-9.55,0-15.19-5.11-15.19-14,0-15.42,9.33-23.32,22.64-23.32C389.82,214.89,393.89,217.83,393.89,223.39Zm-13.24-7.07c-4.06,0-6.39,7.45-7.52,16.55,5.11-.23,9.78-2.71,9.78-12C382.91,218.13,382.45,216.32,380.65,216.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423.67,225.5c1.27-4.89,1.42-6.77-.68-6.77-1.66,0-4.14,1.8-7,7.82-2.71,5.71-4.22,12.48-5,24.66-2.33-.07-12.86.31-15,.76l3.16-14,3.08-21h-5.18l.15-1.36h19l-2.93,12.49.22.07c3.39-7.44,6.92-13.31,15.57-13.31,4.89,0,6.84,2.48,6.84,6.17a18.46,18.46,0,0,1-1.12,5.56l.3.08c2.1-4.59,5.71-11.81,14.59-11.81,5,0,7.74,2.86,7.82,7.07a27.62,27.62,0,0,1-.83,6.47l-3.54,14.14a30.75,30.75,0,0,0-.9,4.73c0,1.51.9,1.81,2,1.81s2.85-1.2,4.73-4.36l1.28.75c-2.85,4.51-5.64,6.69-11.13,6.69-5.71,0-9.85-2.4-9.85-8.8,0-5,3.84-16.39,4.44-17.89,1.28-3.54,2.56-6.77-.15-6.77-1.66,0-3.84,2.33-6.09,6.69-3.24,6.24-5,14.89-6.17,25.79-2.18-.07-12.41.31-14.29.76C418.93,243,421.26,234.9,423.67,225.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.64,309.69H63.78V294.28h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.37,294.28h1.85v15.45H83.1l-10-12.21v12.17H71.22V294.28H74l8.4,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.24,294.28h1.85l-6.74,15.49H94.19l-6.85-15.49H90.4l4.95,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.07,309.69h-2.86V294.28h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.15,295.82h-5.81v-1.54h14.48v1.54H120v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.1,294.28h11v1.57H132V301h6v1.56h-6v5.59h8.47v1.59H129.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.48,294.28h2l-5.84,8.92v6.49h-2.86V303.2l-5.85-8.92h3.34l4.63,7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.29,294.06a7.93,7.93,0,1,1-7.86,7.92A7.75,7.75,0,0,1,172.29,294.06Zm0,14.42c3,0,4.64-2.45,4.64-6.5s-1.65-6.51-4.64-6.51-4.65,2.44-4.65,6.51S169.27,308.48,172.29,308.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.89,294.28v9.4c0,4.09-2.57,6.23-6.2,6.23-4.09,0-6.49-2.29-6.49-6.21v-9.42h2.86v9.18c0,3,1.43,4.66,4,4.66s4-1.49,4-4.66v-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.23,295.82h-5.81v-1.54h14.47v1.54h-5.8v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.8,294.06A7.93,7.93,0,1,1,221,302,7.75,7.75,0,0,1,228.8,294.06Zm0,14.42c3,0,4.65-2.45,4.65-6.5s-1.65-6.51-4.65-6.51-4.64,2.44-4.64,6.51S225.79,308.48,228.8,308.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.16,294.06a6.71,6.71,0,0,1,6.14,3.39l-1.19,1.26a5.1,5.1,0,0,0-4.64-3c-3,0-5.11,2.27-5.11,6.25s2.36,6.25,5.08,6.27a4.93,4.93,0,0,0,4.69-2.88l1.17.9a6.75,6.75,0,0,1-6.25,3.68,7.59,7.59,0,0,1-7.9-7.79A7.82,7.82,0,0,1,253.16,294.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.33,294.28h11v1.57h-8.12V301h6v1.56h-6v5.59h8.47v1.59H262.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.22,294.28h2.87V308.1h7.78v1.59H277.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.44,294.28h11v1.57H294.3V301h6v1.56h-6v5.59h8.47v1.59H291.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.33,309.69V294.28h5.9c3.08,0,5.61,1.08,5.61,3.83,0,2.18-1.83,3.46-4,3.61v0c2.35.08,4.6,1.16,4.6,3.76,0,3-2.56,4.16-5.83,4.16Zm2.86-8.67h2.42c2,0,3.32-.66,3.32-2.64s-1.21-2.6-3.3-2.6h-2.44Zm0,1.52v5.63H312c2.23,0,3.61-.75,3.61-2.8s-1.41-2.83-3.78-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M324.77,309.69h-2.86V294.28h6.53c3.17,0,5.81,1.13,5.81,4.16,0,2.69-2.33,3.79-4.62,3.83v.07a3.62,3.62,0,0,1,3.52,2.75l.79,2.18a8.08,8.08,0,0,0,1.34,2.42h-3.21a10.57,10.57,0,0,1-1-2.16l-.9-2.46a2.55,2.55,0,0,0-2.93-2.07h-2.46Zm0-8.19h2.81c2.14,0,3.61-.79,3.61-2.93,0-1.91-1.36-2.79-3.61-2.79h-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M346.88,305.4h-6.21l-1.82,4.29H337l6.76-15.49H345l6.79,15.49h-3ZM341.29,304h5l-2.53-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.92,295.82h-5.81v-1.54h14.48v1.54h-5.81v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.87,294.28h11v1.57h-8.12V301h6v1.56h-6v5.59h8.47v1.59H369.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.76,295.82H390v-1.54h14.48v1.54h-5.81v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M407.71,294.28h2.86V301h8.16v-6.69h2.86v15.41h-2.86v-7.18h-8.16v7.18h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M426.14,294.28h11v1.57H429V301h6v1.56h-6v5.59h8.47v1.59H426.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M443.9,309.69H441V294.28h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451.33,309.69h-2.86V294.28H455c3.16,0,5.8,1.13,5.8,4.16,0,2.69-2.33,3.79-4.62,3.83v.07a3.64,3.64,0,0,1,3.53,2.75l.79,2.18a8.08,8.08,0,0,0,1.34,2.42h-3.21a10.14,10.14,0,0,1-1-2.16l-.9-2.46A2.54,2.54,0,0,0,453.8,303h-2.47Zm0-8.19h2.82c2.13,0,3.61-.79,3.61-2.93,0-1.91-1.37-2.79-3.61-2.79h-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M480.68,299.92l-3.5,9.85H476l-5.92-15.49h2.95l4.13,11.29,2.71-7.9-1.21-3.39h2.88l3.68,11.07,3.93-11.07H491l-5.64,15.49h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M494.1,294.28h11v1.57H497V301h6v1.56h-6v5.59h8.47v1.59H494.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M509,309.69V294.28h5.09c5.28,0,8.73,2.8,8.73,7.64,0,5.08-3.59,7.77-8.45,7.77Zm4.87-13.93h-2v12.45H514c3.57,0,5.7-2,5.7-6.29C519.73,298,517.6,295.76,513.86,295.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M526.09,309.69V294.28h5.08c5.28,0,8.73,2.8,8.73,7.64,0,5.08-3.58,7.77-8.44,7.77ZM531,295.76h-2v12.45h2.18c3.56,0,5.69-2,5.69-6.29C536.82,298,534.69,295.76,531,295.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M546,309.69h-2.86V294.28H546Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.77,294.28h1.85v15.45H562.5l-10-12.21v12.17h-1.84V294.28h2.75l8.4,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M580.41,309.69l-1-2.18a5.52,5.52,0,0,1-4.73,2.4,7.4,7.4,0,0,1-7.72-7.77,7.93,7.93,0,0,1,8.18-8.08,6.73,6.73,0,0,1,6.25,3.37l-1.21,1.28a5.07,5.07,0,0,0-4.73-3c-3.06,0-5.26,2.27-5.26,6.25s2,6.32,4.93,6.32a3.26,3.26,0,0,0,3.5-3.08V302.4h2.9v7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.72,346.86a7.93,7.93,0,1,1-7.85,7.92A7.75,7.75,0,0,1,126.72,346.86Zm0,14.42c3,0,4.65-2.45,4.65-6.5s-1.65-6.51-4.65-6.51-4.64,2.44-4.64,6.51S123.71,361.28,126.72,361.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149,347.08h1.85v15.45h-1.12l-10-12.21v12.17h-1.85V347.08h2.75l8.41,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.29,356.17l-2.11-.57c-2.6-.73-4.14-1.83-4.14-4.23,0-2.64,2.36-4.51,5.61-4.51a6.5,6.5,0,0,1,5.7,2.78l-1.16,1.25a5.17,5.17,0,0,0-4.56-2.51c-1.74,0-2.95.84-2.95,2.25s.82,1.84,2.64,2.33l2.14.59c2.53.68,4.16,1.85,4.16,4.25,0,3-2.64,4.91-6,4.91a7.23,7.23,0,0,1-6.4-3.28l1.23-1.15a5.94,5.94,0,0,0,5.17,2.82c1.88,0,3.33-.79,3.33-2.44C170,357.23,169,356.65,167.29,356.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184.32,358.2h-6.21l-1.82,4.29h-1.81L181.24,347h1.19l6.8,15.49h-3Zm-5.59-1.43h5L181.17,351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.36,348.62h-5.81v-1.54H204v1.54h-5.81v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.78,347.08v9.4c0,4.09-2.57,6.23-6.2,6.23-4.09,0-6.49-2.29-6.49-6.21v-9.42H210v9.18c0,3,1.43,4.66,4,4.66s4-1.49,4-4.66v-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227,362.49h-2.86V347.08h6.53c3.17,0,5.81,1.13,5.81,4.16,0,2.69-2.33,3.79-4.62,3.83v.07a3.64,3.64,0,0,1,3.52,2.75l.79,2.18a8.08,8.08,0,0,0,1.34,2.42h-3.21a10.57,10.57,0,0,1-1-2.16l-.9-2.46a2.55,2.55,0,0,0-2.93-2.07H227Zm0-8.19h2.81c2.14,0,3.61-.79,3.61-2.93,0-1.91-1.36-2.79-3.61-2.79H227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.7,362.49V347.08h5.09c5.28,0,8.73,2.8,8.73,7.64,0,5.08-3.59,7.77-8.45,7.77Zm4.87-13.93h-2V361h2.18c3.57,0,5.7-2,5.7-6.29C251.44,350.82,249.31,348.56,245.57,348.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.79,358.2h-6.21l-1.83,4.29H256L262.7,347h1.19l6.8,15.49h-3Zm-5.59-1.43h5L262.64,351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.43,347.08h2L279.58,356v6.49h-2.86V356l-5.85-8.92h3.34l4.62,7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.61,359.23h3.14v3.34c0,2.2-1.3,3.48-3.65,3.48v-1.19c1.43,0,2.07-.72,2.07-2.29v-.28h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M309.52,358.13c0,2.79-2.55,4.58-5.85,4.58s-5.7-1.54-5.7-4.1c0-1.93,1.61-3.14,3.32-3.72a4.08,4.08,0,0,1-2.55-3.69c0-2.64,2.22-4.34,5-4.34s4.89,1.43,4.89,3.61a3.76,3.76,0,0,1-2.71,3.35C308.42,354.78,309.52,356.08,309.52,358.13Zm-7.19-2.73c-1.24.6-2.49,1.5-2.49,3.13,0,1.78,1.54,2.81,3.83,2.81,1.8,0,3.28-.88,3.28-2.53,0-1.27-.84-1.94-2.53-2.6Zm1.1-2.55,1.27.48a3.22,3.22,0,0,0,2-2.79c0-1.41-1.17-2.33-3-2.33-1.61,0-2.62.83-2.62,2.15S302.06,352.32,303.43,352.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.35,348.62h-5.81v-1.54H326v1.54h-5.81v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.3,347.08h2.86v6.69h8.16v-6.69h2.86v15.41h-2.86v-7.18h-8.16v7.18H329.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360.8,346.86a7.93,7.93,0,1,1-7.85,7.92A7.75,7.75,0,0,1,360.8,346.86Zm0,14.42c3,0,4.65-2.45,4.65-6.5s-1.65-6.51-4.65-6.51-4.64,2.44-4.64,6.51S357.79,361.28,360.8,361.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.89,346.86a6.71,6.71,0,0,1,6.14,3.39l-1.19,1.26a5.1,5.1,0,0,0-4.65-3c-3,0-5.1,2.27-5.1,6.25s2.35,6.25,5.08,6.27a4.93,4.93,0,0,0,4.69-2.88l1.17.9a6.75,6.75,0,0,1-6.25,3.68,7.59,7.59,0,0,1-7.9-7.79A7.82,7.82,0,0,1,378.89,346.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M392.57,348.62h-5.81v-1.54h14.48v1.54h-5.81v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M410.15,346.86a7.93,7.93,0,1,1-7.86,7.92A7.76,7.76,0,0,1,410.15,346.86Zm0,14.42c3,0,4.64-2.45,4.64-6.5s-1.65-6.51-4.64-6.51-4.64,2.44-4.64,6.51S407.13,361.28,410.15,361.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M421.28,362.49V347.08h5.9c3.08,0,5.61,1.08,5.61,3.83,0,2.18-1.83,3.46-4,3.61v0c2.35.09,4.6,1.17,4.6,3.77,0,2.95-2.56,4.16-5.83,4.16Zm2.86-8.67h2.42c2,0,3.32-.66,3.32-2.64s-1.21-2.6-3.3-2.6h-2.44Zm0,1.51V361h2.77c2.23,0,3.61-.75,3.61-2.8s-1.41-2.84-3.78-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M436.86,347.08h11v1.57h-8.12v5.1h6v1.56h-6v5.59h8.47v1.59H436.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.61,362.49h-2.86V347.08h6.54c3.16,0,5.8,1.13,5.8,4.16,0,2.69-2.33,3.79-4.62,3.83v.07a3.62,3.62,0,0,1,3.52,2.75l.8,2.18a8.08,8.08,0,0,0,1.34,2.42h-3.21a10.14,10.14,0,0,1-1-2.16l-.9-2.46a2.54,2.54,0,0,0-2.92-2.07h-2.47Zm0-8.19h2.82c2.13,0,3.61-.79,3.61-2.93,0-1.91-1.37-2.79-3.61-2.79h-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M484.4,360l-.22,2.47H473.07v-.86l4.09-4c1.94-1.87,3.7-3.78,3.7-6.42a2.56,2.56,0,0,0-2.71-2.77,2.5,2.5,0,0,0-2.77,2.55,2.65,2.65,0,0,0,1.21,2.07l-.95,1a3.3,3.3,0,0,1-2-3c0-2.29,1.81-4.21,4.93-4.21,2.86,0,5.26,1.5,5.26,4.51S481.3,356.44,476,360Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M493,346.86c3.85,0,6.36,3.17,6.36,7.92s-2.51,7.93-6.36,7.93-6.36-3.17-6.36-7.93S489.15,346.86,493,346.86Zm0,14.55c2.25,0,3.21-2.27,3.21-6.63s-1-6.62-3.21-6.62-3.21,2.25-3.21,6.62S490.76,361.41,493,361.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.32,360l-.22,2.47H501v-.86l4.09-4c1.93-1.87,3.7-3.78,3.7-6.42a2.56,2.56,0,0,0-2.71-2.77A2.49,2.49,0,0,0,503.3,351a2.65,2.65,0,0,0,1.21,2.07l-.95,1a3.3,3.3,0,0,1-2-3c0-2.29,1.8-4.21,4.93-4.21,2.86,0,5.26,1.5,5.26,4.51s-2.55,5.07-7.88,8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M525.72,360l-.22,2.47H514.38v-.86l4.1-4c1.93-1.87,3.69-3.78,3.69-6.42a2.55,2.55,0,0,0-2.7-2.77A2.49,2.49,0,0,0,516.7,351a2.65,2.65,0,0,0,1.21,2.07l-.95,1a3.3,3.3,0,0,1-2-3c0-2.29,1.8-4.21,4.93-4.21,2.86,0,5.26,1.5,5.26,4.51s-2.56,5.07-7.88,8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.19,384.6H110l-1.82,4.29h-1.81l6.76-15.49h1.18l6.8,15.49h-3Zm-5.59-1.43h5L113,377.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.23,375h-5.81v-1.54H135.9V375h-5.81v13.87h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.67,388.89V373.48h5.89c3.08,0,5.61,1.08,5.61,3.83,0,2.18-1.82,3.46-4,3.61v0c2.36.09,4.6,1.17,4.6,3.77,0,2.95-2.55,4.16-5.83,4.16Zm2.86-8.67H151c2,0,3.32-.66,3.32-2.64s-1.21-2.6-3.3-2.6h-2.44Zm0,1.51v5.64h2.77c2.22,0,3.61-.75,3.61-2.8s-1.41-2.84-3.79-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.24,373.48h11v1.57H164.1v5.1h6v1.56h-6v5.59h8.47v1.59H161.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M176.13,373.48H179V387.3h7.78v1.59H176.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190.35,373.48h2.86V387.3H201v1.59H190.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.94,384.6h-6.2l-1.83,4.29h-1.8l6.75-15.49h1.19l6.8,15.49h-3Zm-5.59-1.43h5l-2.53-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.67,388.89l-1-2.18a5.52,5.52,0,0,1-4.73,2.4,7.41,7.41,0,0,1-7.73-7.77,7.94,7.94,0,0,1,8.19-8.08,6.74,6.74,0,0,1,6.25,3.37l-1.21,1.28a5.07,5.07,0,0,0-4.73-3c-3.06,0-5.26,2.27-5.26,6.25s2,6.32,4.93,6.32a3.26,3.26,0,0,0,3.5-3.09V381.6h2.9v7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.7,388.89h-2.86V373.48h6.54c3.17,0,5.8,1.13,5.8,4.16,0,2.69-2.33,3.79-4.62,3.83v.07a3.64,3.64,0,0,1,3.53,2.75l.79,2.18a8.08,8.08,0,0,0,1.34,2.42H255a11.21,11.21,0,0,1-1-2.16l-.9-2.46a2.54,2.54,0,0,0-2.92-2.07H247.7Zm0-8.19h2.82c2.13,0,3.61-.79,3.61-2.93,0-1.91-1.37-2.79-3.61-2.79H247.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269.81,384.6h-6.2l-1.83,4.29H260l6.75-15.49h1.19l6.8,15.49h-3Zm-5.59-1.43h5l-2.53-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.18,373.26a6.71,6.71,0,0,1,6.14,3.39l-1.19,1.26a5.1,5.1,0,0,0-4.64-3c-3,0-5.11,2.27-5.11,6.25s2.36,6.25,5.09,6.27a4.93,4.93,0,0,0,4.68-2.88l1.17.9a6.75,6.75,0,0,1-6.25,3.68,7.59,7.59,0,0,1-7.9-7.79A7.82,7.82,0,0,1,284.18,373.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.35,373.48h11v1.57h-8.12v5.1h6v1.56h-6v5.59h8.47v1.59H293.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M327.5,373.48h3.41v15.41h-2.82V376.12L322.81,389h-1l-5.24-12.83v12.77h-1.84V373.48h3.69L323,384.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M343.84,384.6h-6.2l-1.83,4.29H334l6.75-15.49H342l6.8,15.49h-3Zm-5.59-1.43h5l-2.53-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363,373.48h1.85v15.45h-1.13l-10-12.21v12.17h-1.85V373.48h2.75l8.41,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M376,373.26a7.93,7.93,0,1,1-7.86,7.92A7.75,7.75,0,0,1,376,373.26Zm0,14.42c3,0,4.64-2.45,4.64-6.5s-1.65-6.51-4.64-6.51-4.64,2.44-4.64,6.51S373,387.68,376,387.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390,388.89h-2.86V373.48h6.53c3.17,0,5.81,1.13,5.81,4.16,0,2.69-2.33,3.79-4.62,3.83v.07a3.62,3.62,0,0,1,3.52,2.75l.8,2.18a8.08,8.08,0,0,0,1.34,2.42h-3.21a10.14,10.14,0,0,1-1-2.16l-.9-2.46c-.53-1.52-1.14-2.07-2.93-2.07H390Zm0-8.19h2.82c2.13,0,3.6-.79,3.6-2.93,0-1.91-1.36-2.79-3.6-2.79H390Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M403.24,385.63h3.15V389c0,2.2-1.3,3.48-3.66,3.48v-1.19c1.44,0,2.07-.72,2.07-2.29v-.28h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M426,379.12l-3.5,9.85H421.3l-5.92-15.49h2.95l4.14,11.29,2.71-7.9L424,373.48h2.88l3.67,11.07,3.94-11.07h1.81L430.63,389h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445.64,373.26a7.93,7.93,0,1,1-7.86,7.92A7.75,7.75,0,0,1,445.64,373.26Zm0,14.42c3,0,4.64-2.45,4.64-6.5s-1.65-6.51-4.64-6.51-4.65,2.44-4.65,6.51S442.62,387.68,445.64,387.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M463.57,373.26a7.93,7.93,0,1,1-7.86,7.92A7.75,7.75,0,0,1,463.57,373.26Zm0,14.42c3,0,4.64-2.45,4.64-6.5s-1.65-6.51-4.64-6.51-4.65,2.44-4.65,6.51S460.55,387.68,463.57,387.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M487.46,373.48h3.41v15.41h-2.82V376.12L482.77,389h-1l-5.23-12.83v12.77H474.7V373.48h3.69l4.54,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M495.42,388.89V373.48h5.9c3.08,0,5.61,1.08,5.61,3.83,0,2.18-1.83,3.46-4,3.61v0c2.35.09,4.6,1.17,4.6,3.77,0,2.95-2.56,4.16-5.83,4.16Zm2.86-8.67h2.42c2,0,3.32-.66,3.32-2.64s-1.21-2.6-3.3-2.6h-2.44Zm0,1.51v5.64h2.77c2.23,0,3.61-.75,3.61-2.8s-1.41-2.84-3.78-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.67,373.48h2l-5.83,8.91v6.5H515v-6.5l-5.85-8.91h3.34l4.62,7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M526.66,373.48h11v1.57h-8.12v5.1h6v1.56h-6v5.59H538v1.59H526.66Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiCircle);
export default __webpack_public_path__ + "static/media/semi_circle.39db97fb2bbf20a26e2aab2ded029355.svg";
export { ForwardRef as ReactComponent };